import { Box } from "@mui/material";

import { useContext, useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import UserContext from "../../context";
import ContactForm from "../../components/home/contactForm";
import PreFooter from "../../components/home/preFooter";
import HealthPlanComponent from "./components/planos";
import CredenciadaSection from "./components/apresentacao";
import AtendimentoSection from "./components/atendimento";
import AreaBeneficiarioSection from "./components/beneficiario";
import NoticiasBlogSection from "./components/noticias";

import { motion as Motion } from "framer-motion";

import img_1 from "../../assets/images/carroseul-home/img-1.png";
//import img_2 from "../../assets/images/carroseul-home/img-2.jpg";
import img_3 from "../../assets/images/carroseul-home/img-3.jpg";
import img_4 from "../../assets/images/carroseul-home/img-4.jpg";
import img_5 from "../../assets/images/carroseul-home/img-5.jpg";
import img_6 from "../../assets/images/carroseul-home/img-6.jpg";
import img_7 from "../../assets/images/carroseul-home/img-7.png";
import Carousel from "./components/carrossel";

const images = [
    img_1,
    //img_2,
    img_3,
    img_4,
    img_5,
    img_6,
    img_7,
];
export type Planos = "default" |  "individual" | "coletivo" | "empresarial";

const HomePage = () => {

    const navigate = useNavigate();

    const [planoAtual, setPlanoAtual] = useState<Planos>("default");
    
    const ctx = useContext(UserContext);

    useEffect(() => {
        if(!ctx?.user)
            console.log('oi')
    }, []);
    
    useEffect(() => {
        scrollToBottom();
      }, [planoAtual]);
    
    // scroll do histograma das paradas
    const moveEndRef = useRef<HTMLDivElement>(null);
    const scrollToBottom = () => {
        if (moveEndRef.current) {
            moveEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return <Box>
         {/* <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        > */}
            <Carousel images={images} />
            {/* <Image src={img_1} width="100%"/> */}

        {/* </Motion.div> */}
        <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >
            <CredenciadaSection/>
        </Motion.div>
        <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >
            <AreaBeneficiarioSection/>      
        </Motion.div>
        <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >
            <AtendimentoSection handeClickFaleConosco={scrollToBottom}/>
        </Motion.div>

        <HealthPlanComponent setPlanoAtual={(v) => setPlanoAtual(v as Planos)}/>
    
        <Motion.div
            style={{
                backgroundColor: "#0786d0",
                
            }}
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >

        <NoticiasBlogSection/>
        </Motion.div>

        <div ref={moveEndRef}></div>

        <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >
            <ContactForm planoAtual={planoAtual} setPlanoAtual={v => setPlanoAtual(v as Planos)}/>
        </Motion.div>
        <Motion.div
            initial={{ opacity: 0, x: -100}}
            whileInView={{ opacity: 1, x: 0}}
            exit={{ opacity: 0, x: -100}}
            transition={{ duration: 0.5}}
        >
            <PreFooter />
        </Motion.div>
    </Box>
}
export default HomePage;